export const VISIT_STATUS = {
  INSIDE: 'INSIDE',
  CHECKED_OUT: 'CHECKED_OUT',
} as const;

export type VisitStatus = (typeof VISIT_STATUS)[keyof typeof VISIT_STATUS];

export type Visitor = {
  visitorId: number;
  visitorName: string;
  designation: string | null;
  companyName: string;
  phoneNumber: string;
  email: string | null;
  purposeOfVisit: string;
  isInside: boolean;
  lastCheckInAt: string | null;
  createdAt: string | null;
};

export type Visit = {
  visitId: number;
  visitorId: number;
  visitorName: string;
  designation: string | null;
  companyName: string;
  purposeOfVisit: string | null;
  visitDate: string | null;
  visitStatus: VisitStatus;
  checkInAt: string | null;
  checkOutAt: string | null;
};

export type VisitorListFilters = Record<string, never>;

export type VisitHistoryFilters = {
  /** YYYY-MM-DD; empty for all dates. */
  visitDate?: string;
  status?: VisitStatus | null;
};

export type VisitorPage<T> = {
  items: T[];
  page: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
};

/** A face image from the camera or the photo library. */
export type VisitorFaceImage = {
  uri: string;
  fileName: string;
  mimeType: string;
  source: 'CAMERA' | 'UPLOAD';
};

export type VisitorRegistrationInput = {
  visitorName: string;
  designation: string;
  companyName: string;
  phoneNumber: string;
  email: string;
  purposeOfVisit: string;
  consentGiven: boolean;
  faceImage: VisitorFaceImage;
};

export type VisitorFaceResult = {
  visit: Visit;
  message: string;
};

/**
 * Kiosk quick registration (Mark Attendance, unmatched face). The face
 * captured at Mark Attendance is sent alongside it, not entered on the form.
 */
export type QuickVisitorInput = {
  visitorName: string;
  designation: string;
  companyName: string;
  phoneNumber: string;
  email: string;
  purposeOfVisit: string;
};

export type QuickVisitorResult = {
  visitor: Visitor;
  organizationName: string | null;
  welcomeMessage: string;
  /** The face was enrolled and will be recognised at check-out. */
  faceRegistered: boolean;
  /** A visit was opened as part of the registration. */
  checkedIn: boolean;
  visit: Visit | null;
};

/** A registered visitor recognised at Mark Attendance. */
export type VisitorRecognition = {
  action: 'CHECK_IN' | 'CHECK_OUT';
  visit: Visit;
  organizationName: string | null;
  message: string;
};

/** Every field is null when the organization has not configured it. */
export type HrContact = {
  organizationName: string | null;
  contactName: string | null;
  phoneNumber: string | null;
  email: string | null;
};

export type VisitorModuleCapabilities = {
  canViewVisitors: boolean;
  canManageVisitors: boolean;
};
